import { getStringFromObject } from '../../constants/lodashUtils';
import { checkIfPrivilegeExistsForUser } from '../../constants/privilegeChecker';
import {
    editDraftJournalEntriesPrivilege,
    editPostedJournalEntriesPrivilege,
} from '../../constants/privilegeConstants';
import { ACCOUNT_MOVE_STATE } from '../../mapper/JournalEntryMapper';

export const isNewJournalEntry = values => !getStringFromObject('uuid', values, '');

export const isPeriodClosed = values => getStringFromObject('periodStatus', values) === 'done';

export const isJournalReconciled = selectedJournal => Boolean(getStringFromObject('reconciled', selectedJournal));

export const canEditDraftEntry = () => checkIfPrivilegeExistsForUser(editDraftJournalEntriesPrivilege);

export const canEditPostedEntry = () => checkIfPrivilegeExistsForUser(editPostedJournalEntriesPrivilege);

export const canEditJournalEntry = (values, readOnly) => {
    if (readOnly) {
        return false;
    }

    if (isPeriodClosed(values)) {
        return false;
    }
    const state = getStringFromObject('state', values);

    const isDraft = state === ACCOUNT_MOVE_STATE.DRAFT;
    const isPosted = state === ACCOUNT_MOVE_STATE.POSTED;

    if (isDraft) {
        return canEditDraftEntry();
    }
    if (isPosted) {
        return canEditPostedEntry();
    }
    return false;
};
